import { HttpClient } from "@angular/common/http";
import { AppConfig } from "../../global/config/app.config";
import { Inject, Injectable } from "@angular/core";
import { APP_CONFIG } from "../../global/config/config.token";
import { Observable } from "rxjs";
import { DonorFlagFormModel } from "../models/DonorModel";
import { CSFundCode } from "../models/CampaignSettingsModels";

@Injectable({
    providedIn: 'root'
})
export class CampaignSettingsService {
    constructor(private httpClient: HttpClient,
                @Inject(APP_CONFIG) private config: AppConfig)
    { }

    getFundcodes = (campaignId: number): Observable<CSFundCode[]> => {
        return this.httpClient.get<CSFundCode[]>(`${this.config.apiUrl}campaignsettings/get-fundcodes?campaignId=` + campaignId, { withCredentials: true });
    }

    saveFundcode = (fundCodeFormModel: any): Observable<any> => {
        return this.httpClient.post(`${this.config.apiUrl}CampaignSettings/add-update-fundcode`, fundCodeFormModel, { withCredentials: true });
    }

    getFundcodeCheckbooks = (campaignId: number): Observable<any> => {
        return this.httpClient.get(`${this.config.apiUrl}campaignsettings/get-fundcode-checkbooks?campaignId=` + campaignId, { withCredentials: true });
    }

    saveFundcodeCheckbooks = (fundCodeFormModel: any): Observable<any> => {
        return this.httpClient.post(`${this.config.apiUrl}CampaignSettings/add-update-fundcode-checkbooks`, fundCodeFormModel, { withCredentials: true });
    }
}